/* PDF export (print route). The page is laid out at the PDF's own width
   (1444px, as d360), so what's on screen is what prints. */

.print {
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
}

/* Tab heading: the tab's own name in sentence case, ruled off like the
   on-screen tab bar (crimson underline), not a shouted display heading */
.sectionTitle {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin: 0 0 var(--space-6);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--border-default);
  font-family: var(--font-sans);
  font-size: var(--text-3xl, 30px);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-tight);
  color: var(--text-primary);
}

.sectionTitle::before {
  content: '';
  width: 4px;
  height: 1em;
  border-radius: 2px;
  background: var(--accent-primary);
}

/* ── On-screen toolbar ── */

.toolbar {
  position: fixed;
  top: var(--space-4);
  right: var(--space-4);
  z-index: var(--z-overlay);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-2) var(--space-2) var(--space-4);
  background: var(--bg-elevated);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}

.status {
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.toolbarButton {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 34px;
  padding: 0 var(--space-3);
  background: var(--bg-base);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: var(--weight-semi);
  cursor: pointer;
}

.toolbarButton:hover:not(:disabled) {
  border-color: var(--border-strong);
}

.toolbarButton:disabled {
  opacity: 0.5;
  cursor: default;
}

/* ── Print ── */

/* The page box (@page) is injected by the component, see there. These rules
   key off html[data-pdf-export], which only this route sets, because every
   CSS module lands in the one app stylesheet. */
@media print {
  :global(html[data-pdf-export]),
  :global(html[data-pdf-export]) :global(body) {
    width: 1444px;
    margin: 0;
    background: var(--bg-base) !important;
  }

  :global(html[data-pdf-export]) :global(*) {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  :global(html[data-pdf-export]) :global([data-print-hide]) {
    display: none !important;
  }

  /* Never split a chart, table or tile row across pages; let everything
     else flow so pages fill up */
  .print :global([data-print-keep]) {
    break-inside: avoid;
  }

  .sectionTitle {
    break-after: avoid;
  }
}
